import useSWR from "swr";
import { apiBaseURL } from "../../Utils/ProjectConstants";

export default function useGetHolidays(currentYear, currentMonth) {
  const { data, error, mutate, isLoading } = useSWR(
    `${apiBaseURL}/api/holidays/${currentYear}/${currentMonth}`,
    {
      onSuccess: (data) =>
        console.log("Holidays fetched successfully:", data?.data),
      revalidateOnFocus: false,
      dedupingInterval: 300000,
    }
  );

  const holiday = data?.data?.map((x) => ({
    label: `${x.name}`,
    value: x.date,
  }));

  return {
    holiday,
  };
}
